// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCCOHwoGmExDFoLfYxtPioCPIFY0pjBM48",
  authDomain: "funkopopv2.firebaseapp.com",
  databaseURL: "https://funkopopv2-default-rtdb.firebaseio.com",
  projectId: "funkopopv2",
  storageBucket: "funkopopv2.appspot.com",
  messagingSenderId: "841277743512",
  appId: "1:841277743512:web:b209b305bf02e11d538bed",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyAVkM-LPvEJ6uLrLT1nwdb4Dis5_7XoKe8",
//   authDomain: "funko-pop-version-test.firebaseapp.com",
//   databaseURL: "https://funko-pop-version-test-default-rtdb.firebaseio.com",
//   projectId: "funko-pop-version-test",
//   storageBucket: "funko-pop-version-test.appspot.com",
//   messagingSenderId: "160198086984",
//   appId: "1:160198086984:web:dfeb20155e895c3c63637d"
// };

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;